import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { UsersService } from "../../pages/users/users.service";
import { MaterialModule } from "src/app/app.materials";

@Component({
  selector: "app-datawrapper-dialog",
  templateUrl: "./datawrapper-dialog.component.html",
  styleUrls: ["./datawrapper-dialog.component.scss"],
  imports: [MaterialModule],
  standalone: true,
})
export class DatawrapperDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DatawrapperDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
